<template>
  <img
    src="/disposal-queen-logo.png"
    alt="Disposal Queen"
    height="40"
    style="height: 40px; width: auto; object-fit: contain;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
